<template>
  <el-tooltip
    effect="dark"
    :content="isFullScreen ? '退出全屏' : '全屏模式'"
    placement="top"
  >
    <app-icon
      class="c_cursor"
      :size="20"
      :name="isFullScreen ? 'fullscreen-exit-line' : 'fullscreen-line'"
      @click="toggleFullScreen"
    />
  </el-tooltip>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

const isFullScreen = ref(false)

const toggleFullScreen = () => {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen()
    isFullScreen.value = true
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen()
      isFullScreen.value = false
    }
  }
}
</script>
